import mutations from './mutations'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'clients'

export default {
  namespaced: true,

  state: {
    items: {},
    filter: localStorage.getItem('clientsFilter') || ''
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    setFilter ({ commit }, filter) {
      commit('updateFilter', filter)
    }
  },

  mutations: {
    ...mutations,
    updateFilter (state, filter) {
      filter ? localStorage.setItem('clientsFilter', filter) : localStorage.removeItem('clientsFilter')
      state.filter = filter
    }
  }
}
